import { render } from "./MenuHeadMs.vue?vue&type=template&id=c906dec2"
import script from "./MenuHeadMs.vue?vue&type=script&lang=js"
export * from "./MenuHeadMs.vue?vue&type=script&lang=js"

import "./MenuHeadMs.vue?vue&type=style&index=0&id=c906dec2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__